export const BookingTypesEnum = {
	FREE: 1,
	NORMAL: 2,
	MEALPLAN: 3
};
